module.exports = __webpack_public_path__ + "fonts/Karla-ExtraBold.deb29eda.ttf";